import { render, staticRenderFns } from "./GamiMaltsHistory.vue?vue&type=template&id=1f55f0b9&scoped=true"
import script from "./GamiMaltsHistory.vue?vue&type=script&lang=js"
export * from "./GamiMaltsHistory.vue?vue&type=script&lang=js"
import style0 from "./GamiMaltsHistory.vue?vue&type=style&index=0&id=1f55f0b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f55f0b9",
  null
  
)

export default component.exports